import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import UpsetChart from '../News/components/upsetChart'
import HeatmapCarousel from './components/HeatmapCarousel'
import DownloadModal from '../News/components/downloadModal'
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
// constants
import {
  descriptionAnimation,
  titleAnimation,
  subtitleAnimation,
} from '../../../constants/animation'
import { upsetData, upsetSetNames } from '../News/components/upsetChart/data'
// assets
import Glow from '../../glows'

const NSF = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <section className='overview-section nsf-section-wrapper'>
      <div className='box'>
        <Glow />
        <Glow position='right' />
        <AnimatedContainer>
          <motion.div
            className='research-main-title-wrapper'
            variants={titleAnimation}
          >
            <motion.span className='research-main-title'>
              Research & Innovation
            </motion.span>
            <motion.span className='research-main-subtitle'>
              Backed by the National Science Foundation
            </motion.span>
            <motion.span className='research-main-title-description'>
              Pod leads pioneering research into AI-driven skills taxonomies and
              workforce mapping, ensuring clients stay ahead of tomorrow's
              challenges.
            </motion.span>
          </motion.div>
        </AnimatedContainer>

        <AnimatedContainer className='research-second-grid'>
          <div>
            <motion.span
              className='overview-title'
              variants={subtitleAnimation}
            >
              AI-Powered Skills Mapping and Regional Strategy for Emerging
              Industries
            </motion.span>
            <motion.p className='description' variants={descriptionAnimation}>
              Pod began mapping jobs from publicly available sources such as
              Google, LinkedIn and Glassdoor. Pod looked at Ohio's 7 economic
              regions as well as neighboring metropolitan areas and curated
              nearly half a million jobs.
            </motion.p>
            <div className='nsf-button-container'>
              <button
                className='nsf-button'
                onClick={() => {
                  setIsOpen(true)
                }}
              >
                Download Report
              </button>
            </div>
          </div>
          <div className='research-img-container'>
            <HeatmapCarousel />
          </div>
        </AnimatedContainer>
        <p className='description'>
          Click the blue blocks below to see the most common intersecting
          skillsets
        </p>
        <UpsetChart
          data={upsetData}
          setNames={upsetSetNames}
          setIsOpen={setIsOpen}
        />
        <DownloadModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          setIsOpen={setIsOpen}
        />
      </div>
    </section>
  )
}

export default NSF
